// src/components/landing/Footer.tsx
import React from "react";
import { Phone, Mail } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-slate-100 bg-[#F8FAFD]">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <img src="/adrojlogo.png" alt="Adroj" className="h-9 w-auto" />
            <p className="mt-4 max-w-xs text-sm text-slate-500">
              India&apos;s marketplace for outdoor advertising space — hoardings, unipoles, LED screens, transit and mall media.
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["IG", "IN", "X"].map((s) => (
                <span
                  key={s}
                  className="flex h-8 w-8 items-center justify-center rounded-full border border-slate-200 text-[10px] font-semibold text-slate-500 transition-colors hover:border-slate-300 hover:text-[#0F172A]"
                >
                  {s}
                </span>
              ))}
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">For brands</p>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-600">
              <li><a href="#listings" className="hover:text-[#0F172A]">Browse spaces</a></li>
              <li><a href="#how-it-works" className="hover:text-[#0F172A]">How it works</a></li>
              <li><a href="#top" className="hover:text-[#0F172A]">Request a quote</a></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">For owners</p>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-600">
              <li><a href="#for-owners" className="hover:text-[#0F172A]">List your space</a></li>
              <li><a href="#for-owners" className="hover:text-[#0F172A]">Pricing & payouts</a></li>
              <li><a href="#for-owners" className="hover:text-[#0F172A]">Owner guidelines</a></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">Contact</p>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-600">
              <li className="flex items-center gap-2"><Phone className="h-3.5 w-3.5" /> 1800-233-4567</li>
              <li className="flex items-center gap-2"><Mail className="h-3.5 w-3.5" /> hello@adroj.com</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-slate-200 pt-6 text-xs text-slate-400 sm:flex-row">
          <p>&copy; {new Date().getFullYear()} Adroj Media Pvt. Ltd. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href="/privacy-policy" className="hover:text-[#0F172A]">Privacy</a>
            <a href="#" className="hover:text-[#0F172A]">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}